import { useEffect, useState } from 'react';

// Tracks the user's `prefers-reduced-motion` setting reactively, so
// JS-driven motion (parallax, cursor-follow glow) can be skipped entirely
// rather than only the CSS transitions being neutralised. See apple-design §14.
const QUERY = '(prefers-reduced-motion: reduce)';

export const usePrefersReducedMotion = (): boolean => {
  const [prefersReduced, setPrefersReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const update = () => setPrefersReduced(mq.matches);
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return prefersReduced;
};
